<template>
  <div>
    <div class="dialog-login-title">
      <i class="el-icon-back" @click="back" />
      <h1>重置密码</h1>
    </div>
    <el-form :rules="rules" ref="form":model="form" v-if="formRestart" class="login-input">
      <el-form-item prop="phone">
        <i class="el-icon-mobile-phone" />
        <el-input v-model="form.phone" placeholder="输入手机号" type="number" maxlength="11"></el-input>
      </el-form-item>
      <el-form-item prop="code">
        <i class="el-icon-lock" />
        <el-input v-model="form.code" placeholder="请输入验证码" type="number">
          <template slot="append" class="pointer" :phone="form.phone">
            <div @click="sendCode" v-if="!againSend" class="codeText">获取验证码</div>
            <div v-else>{{'重新发送 ' + curCount }}</div>
            <gtDemo v-show="false" ref="verify" @success="sendSuccess"/>
          </template>
        </el-input>
      </el-form-item>
      <el-form-item prop="password">
        <i class="el-icon-lock" />
        <el-input v-model="form.password" placeholder="输入新密码" type="password" @keyup.enter.native="submit"></el-input>
      </el-form-item>
    </el-form>
    <div class="login-btn w_90 marginCenter">
      <el-button type="primary" class="w_100" color="#FFF" @click="submit">提 交</el-button>
    </div>
  </div>
</template>

<script>
  import gtDemo from "./gt"
  import { resetPwdSms,resetPwd } from "../../../api/login";
  export default {
    name: "forget",
    components:{ gtDemo },
    props:{
      mobile:{
        type: String,
        default:_=>{
          return ''
        }
      }
    },
    data(){
      // 手机号验证
      let checkPhone = (rule, value, callback) => {
        const phoneReg = /^1[3456789]\d{9}$/
        if (!value) {
          return callback(new Error('请输入手机号'))
        }
        setTimeout(() => {
          if (phoneReg.test(value)) {
            callback()
          } else {
            callback(new Error('请输入正确手机号'))
          }
        }, 100)
      };
      return{
        form:{
          phone: this.mobile,
          code: '',
          password: ''
        },
        formRestart: true,
        rules: {
          phone: [
            {required: true, validator: checkPhone, trigger: 'blur'},
          ],
          code: [
            {required: true, message: '请输入验证码', trigger: 'change'}
          ],
          password: [
            {required: true, message: '请输入新密码', trigger: 'change'}
          ],
        },
        againSend: false,
        curCount: '',
      }
    },
    mounted() {

    },
    methods:{
      submit(){
        this.$refs['form'].validate((valid) => {
          if (valid) {
            resetPwd({
              mobile: this.form.phone,
              code: this.form.code,
              pwd: this.form.password,
            }).then(_=>{
              this.$message.success('修改成功')
              this.back()
            })
          }else {
            return false;
          }
        })
      },
      // 发送验证码之前的验证
      sendCode(){
        this.$refs['form'].validateField('phone', valid => {
          if (!valid) {
            this.$refs.verify.gt()
          } else {
            return false;
          }
        });
      },
      // 验证码发送成功以后倒计时重复发送
      SetRemainTimes (){
        if(this.curCount == 0) {
          window.clearInterval(this.InterValObj);
          this.againSend = false
        } else {
          this.curCount --;
        }
      },
      sendSuccess(res){
        resetPwdSms({
          geetest_challenge: res.geetest_challenge,
          geetest_validate: res.geetest_validate,
          geetest_seccode: res.geetest_seccode,
          mobile: this.form.phone
        }).then(()=>{
          this.curCount = 120
          this.againSend = true
          this.InterValObj = window.setInterval(this.SetRemainTimes, 1000);
        })
      },
      back(){
        this.$emit('forget')
      }
    }
  }
</script>

<style scoped>
  >>>.el-icon-back{
    position: absolute;
    top: 0.3rem;
    left: 0.2rem;
    font-size: 20px;
    color: #909399;
    cursor: pointer;
  }
  .dialog-login-title h1{
    font-size: 0.3rem;
  }
  .login-btn{
    margin: 1rem auto 0.3rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/login/modal/forget.vue